// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"ResearchMultimedia_wrapper__Ln5D6"};